"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DateTimeless", {
  enumerable: true,
  get: function get() {
    return _DateTimeless["default"];
  }
});
exports["default"] = void 0;

var _DateTimeless = _interopRequireDefault(require("./DateTimeless"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = _DateTimeless["default"];
exports["default"] = _default;